import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import "../CSS/Memberform.css";

const MemberForm = () => {
  const [formData, setFormData] = useState({
    names: [],
    personIds: [],
    fromDate: "",
    toDate: "",
    trainingTimeFrom: "",
    trainingTimeTo: "",
    sport: "",
  });

  const resetForm = () => {
    setFormData({
      names: [],
      personIds: [],
      fromDate: "",
      toDate: "",
      trainingTimeFrom: "",
      trainingTimeTo: "",
      sport: "",
    });
    setEditingId(null);
  };
  

  const [names, setNames] = useState([]);
  const sportsOptions = [
    { value: "Badminton", label: "Badminton" },
    { value: "Dance", label: "Dance" },
    { value: "Yoga", label: "Yoga" },
  ];

  useEffect(() => {
    axios
      .get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getNames")
      .then((response) => {
        const namesArray = Object.values(response.data).map((person) => ({
          id: person.personId,
          label: `${person.personId}-${person.name}`,
          value: person.name,
        }));
        setNames(namesArray);
      });
  }, []);

  const handleSelectChange = (selectedOptions) => {
    const selectedNames = selectedOptions.map((option) => option.value);
    const selectedIds = selectedOptions.map((option) => option.id);
    setFormData((prev) => ({
      ...prev,
      names: selectedNames || [], // Ensure names is an array
      personIds: selectedIds || [], // Ensure personIds is an array
    }));
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSportChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, sport: selectedOption.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.names.length || !formData.sport) {
        alert("Please fill all required fields.");
        return;
      }
      
    try {
      if (editingId) {
        await axios.put(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updateMembership/${editingId}`, formData);
        alert("Membership updated successfully!");
        setEditingId(null);
      } else {
        console.log("Submitting form data:", formData);
        const response = await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addMembership", formData);
        alert(`Membership added successfully! Membership ID: ${response.data.membershipId}`);
      }

      setFormData({
        names: [],
        personIds: [],
        fromDate: "",
        toDate: "",
        trainingTimeFrom: "",
        trainingTimeTo: "",
        sport: "",
      });

      const membershipsResponse = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getMemberships");
      setMemberships(
        Object.entries(membershipsResponse.data).map(([key, value], index) => ({
          ...value,
          key,
          sNo: index + 1,
        }))
      );
    } catch (error) {
      console.error("Error submitting membership:", error);
      alert("Failed to submit membership.");
    }
  };

  const [memberships, setMemberships] = useState([]);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getMemberships");
        setMemberships(
          Object.entries(response.data).map(([key, value], index) => ({
            ...value,
            key,
            sNo: index + 1,
          }))
        );
      } catch (error) {
        console.error("Error fetching memberships:", error);
      }
    };

    fetchMemberships();
  }, []);

  const handleEdit = (membership) => {
    setEditingId(membership.key);
    setFormData({
      names: membership.names,
      personIds: membership.personIds,
      fromDate: membership.fromDate,
      toDate: membership.toDate,
      trainingTimeFrom: membership.trainingTimeFrom,
      trainingTimeTo: membership.trainingTimeTo,
      sport: membership.sport,
    });
  };

  const handleDelete = async (key) => {
    try {
      await axios.delete(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/deleteMembership/${key}`);
      setMemberships((prev) => prev.filter((membership) => membership.key !== key));
      alert("Membership deleted successfully!");
    } catch (error) {
      console.error("Error deleting membership:", error);
      alert("Failed to delete membership.");
    }
  };

  return (
    <div className="container memberform">
      <h3 className="text-center">Membership Form</h3>
      <form onSubmit={handleSubmit}>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Names:</label>
          <Select
            isMulti
            options={names}
            value={names.filter((option) => formData.names.includes(option.value))}
            onChange={handleSelectChange}
            placeholder="Select or search names"
          />
        </div>
        <div className="col-md-2">
          <label>Sport:</label>
          <Select
            options={sportsOptions}
            value={sportsOptions.find((option) => option.value === formData.sport)}
            onChange={handleSportChange}
            placeholder="Select a sport"
          />
        </div>
        <div className="col-md-3">
          <label>From Date:</label>
          <input
            type="date"
            className="form-control"
            name="fromDate"
            value={formData.fromDate}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-md-3">
          <label>To Date:</label>
          <input
            type="date"
            className="form-control"
            name="toDate"
            value={formData.toDate}
            onChange={handleInputChange}
          />
        </div>
       
      </div>
      <div className="row mb-3">
      <div className="col-md-2">
          <label>Training Time From:</label>
          <input
            type="time"
            className="form-control"
            name="trainingTimeFrom"
            value={formData.trainingTimeFrom}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-md-2">
          <label>Training Time To:</label>
          <input
            type="time"
            className="form-control"
            name="trainingTimeTo"
            value={formData.trainingTimeTo}
            onChange={handleInputChange}
          />
        </div>
       
        </div>
        <div className="form-group mt-4">
          <button type="submit" className="btn mr-2">
            Submit
          </button>
          <button type="button" className="btn btn-secondary" onClick={resetForm}>
            Cancel
            </button>

        </div>
      </form>

      <table className="table mt-4">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Membership ID</th>
            <th>Names</th>
            <th>IDs</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Training Time</th>
            <th>Sport</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {memberships.map((membership) => (
            <tr key={membership.key}>
              <td>{membership.sNo}</td>
              <td>{membership.membership_id}</td>
              <td>{membership.names.join(", ")}</td>
              <td>{membership.personIds.join(", ")}</td>
              <td>{membership.fromDate}</td>
              <td>{membership.toDate}</td>
              <td>
                {membership.trainingTimeFrom} - {membership.trainingTimeTo}
              </td>
              <td>{membership.sport}</td>
              <td>
                <button className="btn btn-warning btn-sm" onClick={() => handleEdit(membership)}>
                  Edit
                </button>
              </td>
              <td>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(membership.key)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MemberForm;
